import * as actionsImport from './prospect.actions';
import * as typesImport from './prospect.types';
import * as reducersImport from './reducers';
import * as selectorsImport from './selectors/index';

export const actions = actionsImport;
export const reducers = reducersImport;
export const selectors = selectorsImport;
export const types = typesImport;
